<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="go-back" @click="goBack">返回</div>
        <div class="details-wrap">
          <div class="details-title">好设计是尽可能的无设计</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "messageDetails",
  data() {
    return {
      active: 0,
    };
  },
  mounted() {
    // this.active = Number(localStorage.getItem("active")) || 0;
  },
  methods: {
    // 返回
    goBack(){
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.details-wrap{
  padding-top: 30px;
  .details-title{
    font-size: 26px;
    font-weight: 500;
    color: #2C2C2E;
    line-height: 37px;
  }
}
</style>